function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function encodeLength(x) {
  const output = [];

  do {
    let encodedByte = x % 128;
    x = Math.floor(x / 128);

    if (x > 0) {
      encodedByte = encodedByte | 128;
    }

    output.push(encodedByte);
  } while (x > 0);

  return output;
}

function decodeLength(buffer, startIndex) {
  let i = startIndex;
  let encodedByte = 0;
  let value = 0;
  let multiplier = 1;

  do {
    encodedByte = buffer[i++];
    value += (encodedByte & 127) * multiplier;

    if (multiplier > 128 * 128 * 128) {
      throw Error('malformed length');
    }

    multiplier *= 128;
  } while ((encodedByte & 128) != 0);

  return {
    length: value,
    bytesUsedToEncodeLength: i - startIndex
  };
}

function encodeUTF8String(str, encoder) {
  const bytes = encoder.encode(str);
  return [bytes.length >> 8, bytes.length & 255, ...bytes];
}

function decodeUTF8String(buffer, startIndex, utf8Decoder) {
  const length = (buffer[startIndex] << 8) + buffer[startIndex + 1];
  const bytes = buffer.slice(startIndex + 2, startIndex + 2 + length);
  const value = utf8Decoder.decode(bytes);
  return {
    length: length + 2,
    value
  };
}

const __default = {
  encode(packet, utf8Encoder) {
    const packetType = 1;
    const flags = 0;
    const protocolName = encodeUTF8String('MQTT', utf8Encoder);
    const protocolLevel = 4;
    const usernameFlag = !!packet.username;
    const passwordFlag = !!packet.password;
    const willRetain = !!(packet.will && packet.will.retain);
    const willQoS = packet.will && packet.will.qos || 0;
    const willFlag = !!packet.will;
    const cleanSession = packet.clean || typeof packet.clean === 'undefined';
    const connectFlags = (usernameFlag ? 128 : 0) + (passwordFlag ? 64 : 0) + (willRetain ? 32 : 0) + (willQoS & 2 ? 16 : 0) + (willQoS & 1 ? 8 : 0) + (willFlag ? 4 : 0) + (cleanSession ? 2 : 0);
    const keepAlive = packet.keepAlive && typeof packet.keepAlive !== 'undefined' ? packet.keepAlive : 0;
    const variableHeader = [...protocolName, 4, connectFlags, keepAlive >> 8, keepAlive & 255];
    const payload = [...encodeUTF8String(packet.clientId, utf8Encoder)];

    if (packet.username) {
      payload.push(...encodeUTF8String(packet.username, utf8Encoder));
    }

    if (packet.password) {
      payload.push(...encodeUTF8String(packet.password, utf8Encoder));
    }

    const fixedHeader = [1 << 4 | 0, ...encodeLength(variableHeader.length + payload.length)];
    return [...fixedHeader, ...variableHeader, ...payload];
  },

  decode(buffer, remainingStart, _remainingLength, utf8Decoder) {
    const protocolNameStart = remainingStart;
    const protocolName = decodeUTF8String(buffer, protocolNameStart, utf8Decoder);
    const protocolLevelIndex = protocolNameStart + protocolName.length;
    const protocolLevel = buffer[protocolLevelIndex];
    const connectFlagsIndex = protocolLevelIndex + 1;
    const connectFlags = buffer[connectFlagsIndex];
    const usernameFlag = !!(connectFlags & 128);
    const passwordFlag = !!(connectFlags & 64);
    const willRetain = !!(connectFlags & 32);
    const willQoS = (connectFlags & 16 + 8) >> 3;
    const willFlag = !!(connectFlags & 4);
    const cleanSession = !!(connectFlags & 2);

    if (willQoS !== 0 && willQoS !== 1 && willQoS !== 2) {
      throw new Error('invalid will qos');
    }

    const keepAliveIndex = connectFlagsIndex + 1;
    const keepAlive = (buffer[keepAliveIndex] << 8) + buffer[keepAliveIndex + 1];
    const clientIdStart = keepAliveIndex + 2;
    const clientId = decodeUTF8String(buffer, clientIdStart, utf8Decoder);
    let username;
    let password;
    const usernameStart = clientIdStart + clientId.length;

    if (usernameFlag) {
      username = decodeUTF8String(buffer, usernameStart, utf8Decoder);
    }

    if (passwordFlag) {
      const passwordStart = usernameStart + (username ? username.length : 0);
      password = decodeUTF8String(buffer, passwordStart, utf8Decoder);
    }

    return {
      type: 'connect',
      protocolName: protocolName.value,
      protocolLevel,
      clientId: clientId.value,
      username: username ? username.value : undefined,
      password: password ? password.value : undefined,
      will: willFlag ? {
        retain: willRetain,
        qos: willQoS
      } : undefined,
      clean: cleanSession,
      keepAlive
    };
  }

};
const __default1 = {
  encode(packet) {
    const packetType = 2;
    const flags = 0;
    return [(2 << 4) + 0, 2, packet.sessionPresent ? 1 : 0, packet.returnCode || 0];
  },

  decode(buffer, _remainingStart, _remainingLength) {
    const sessionPresent = !!(buffer[2] & 1);
    const returnCode = buffer[3];
    return {
      type: 'connack',
      sessionPresent,
      returnCode
    };
  }

};
const __default2 = {
  encode(packet, utf8Encoder) {
    const packetType = 3;
    const qos = packet.qos || 0;
    const flags = (packet.dup ? 8 : 0) + (qos & 2 ? 4 : 0) + (qos & 1 ? 2 : 0) + (packet.retain ? 1 : 0);
    const variableHeader = [...encodeUTF8String(packet.topic, utf8Encoder)];

    if (qos === 1 || qos === 2) {
      if (typeof packet.id !== 'number' || packet.id < 1) {
        throw new Error('when qos is 1 or 2, packet must have id');
      }

      variableHeader.push(packet.id >> 8, packet.id & 255);
    }

    let payload = packet.payload;

    if (typeof payload === 'string') {
      payload = utf8Encoder.encode(payload);
    }

    const fixedHeader = [3 << 4 | flags, ...encodeLength(variableHeader.length + payload.length)];
    return [...fixedHeader, ...variableHeader, ...payload];
  },

  decode(buffer, remainingStart, remainingLength, utf8Decoder) {
    const flags = buffer[0] & 15;
    const dup = !!(flags & 8);
    const qos = (flags & 6) >> 1;
    const retain = !!(flags & 1);

    if (qos !== 0 && qos !== 1 && qos !== 2) {
      throw new Error('invalid qos');
    }

    const topicStart = remainingStart;
    const decodedTopic = decodeUTF8String(buffer, topicStart, utf8Decoder);
    const topic = decodedTopic.value;
    let id = 0;
    let payloadStart = topicStart + decodedTopic.length;

    if (qos > 0) {
      const idStart = payloadStart;
      id = (buffer[idStart] << 8) + buffer[idStart + 1];
      payloadStart += 2;
    }

    const payload = buffer.slice(payloadStart, remainingStart + remainingLength);
    return {
      type: 'publish',
      topic,
      payload,
      dup,
      retain,
      qos,
      id
    };
  }

};
const __default3 = {
  encode(packet) {
    const packetType = 4;
    const flags = 0;
    return [(4 << 4) + 0, 2, packet.id >> 8, packet.id & 255];
  },

  decode(buffer, _remainingStart, _remainingLength) {
    const id = (buffer[2] << 8) + buffer[3];
    return {
      type: 'puback',
      id
    };
  }

};
const __default4 = {
  encode(packet) {
    const packetType = 5;
    const flags = 0;
    return [(5 << 4) + 0, 2, packet.id >> 8, packet.id & 255];
  },

  decode(buffer, _remainingStart, _remainingLength) {
    const id = (buffer[2] << 8) + buffer[3];
    return {
      type: 'pubrec',
      id
    };
  }

};
const __default5 = {
  encode(packet) {
    const packetType = 6;
    const flags = 2;
    return [(6 << 4) + 2, 2, packet.id >> 8, packet.id & 255];
  },

  decode(buffer, _remainingStart, _remainingLength) {
    const id = (buffer[2] << 8) + buffer[3];
    return {
      type: 'pubrel',
      id
    };
  }

};
const __default6 = {
  encode(packet) {
    const packetType = 7;
    const flags = 0;
    return [(7 << 4) + 0, 2, packet.id >> 8, packet.id & 255];
  },

  decode(buffer, _remainingStart, _remainingLength) {
    const id = (buffer[2] << 8) + buffer[3];
    return {
      type: 'pubcomp',
      id
    };
  }

};
const __default7 = {
  encode(packet, utf8Encoder) {
    const packetType = 8;
    const flags = 2;
    const variableHeader = [packet.id >> 8, packet.id & 255];
    const payload = [];

    for (const sub of packet.subscriptions) {
      payload.push(...encodeUTF8String(sub.topicFilter, utf8Encoder), sub.qos);
    }

    const fixedHeader = [8 << 4 | 2, ...encodeLength(variableHeader.length + payload.length)];
    return [...fixedHeader, ...variableHeader, ...payload];
  },

  decode(buffer, remainingStart, _remainingLength, utf8Decoder) {
    const idStart = remainingStart;
    const id = (buffer[idStart] << 8) + buffer[idStart + 1];
    const subscriptionsStart = idStart + 2;
    const subscriptions = [];

    for (let i = subscriptionsStart; i < buffer.length;) {
      const topicFilter = decodeUTF8String(buffer, i, utf8Decoder);
      i += topicFilter.length;
      const qos = buffer[i];
      i += 1;

      if (qos !== 0 && qos !== 1 && qos !== 2) {
        throw new Error('invalid qos');
      }

      subscriptions.push({
        topicFilter: topicFilter.value,
        qos
      });
    }

    return {
      type: 'subscribe',
      id,
      subscriptions
    };
  }

};
const __default8 = {
  encode(packet) {
    const packetType = 9;
    const flags = 0;
    return [(9 << 4) + 0, 2 + packet.returnCodes.length, packet.id >> 8, packet.id & 255, ...packet.returnCodes];
  },

  decode(buffer, remainingStart, _remainingLength) {
    const idStart = remainingStart;
    const id = (buffer[idStart] << 8) + buffer[idStart + 1];
    const payloadStart = idStart + 2;
    const returnCodes = [];

    for (let i = payloadStart; i < buffer.length; i++) {
      returnCodes.push(buffer[i]);
    }

    return {
      type: 'suback',
      id,
      returnCodes
    };
  }

};
const __default9 = {
  encode(packet, utf8Encoder) {
    const packetType = 10;
    const flags = 2;
    const variableHeader = [packet.id >> 8, packet.id & 255];
    const payload = [];

    for (const topic of packet.topicFilters) {
      payload.push(...encodeUTF8String(topic, utf8Encoder));
    }

    const fixedHeader = [10 << 4 | 2, ...encodeLength(variableHeader.length + payload.length)];
    return [...fixedHeader, ...variableHeader, ...payload];
  },

  decode(buffer, remainingStart, _remainingLength, utf8Decoder) {
    const idStart = remainingStart;
    const id = (buffer[idStart] << 8) + buffer[idStart + 1];
    const topicFiltersStart = idStart + 2;
    const topicFilters = [];

    for (let i = topicFiltersStart; i < buffer.length;) {
      const topicFilter = decodeUTF8String(buffer, i, utf8Decoder);
      i += topicFilter.length;
      topicFilters.push(topicFilter.value);
    }

    return {
      type: 'unsubscribe',
      id,
      topicFilters
    };
  }

};
const __default10 = {
  encode(packet) {
    const packetType = 11;
    const flags = 0;
    return [(11 << 4) + 0, 2, packet.id >> 8, packet.id & 255];
  },

  decode(buffer, _remainingStart, _remainingLength) {
    const id = (buffer[2] << 8) + buffer[3];
    return {
      type: 'unsuback',
      id
    };
  }

};
const __default11 = {
  encode(_packet) {
    const packetType = 12;
    const flags = 0;
    return [(12 << 4) + 0, 0];
  },

  decode(_buffer, _remainingStart, _remainingLength) {
    return {
      type: 'pingreq'
    };
  }

};
const __default12 = {
  encode(_packet) {
    return [208, 0];
  },

  decode(_buffer, _remainingStart, _remainingLength) {
    return {
      type: 'pingres'
    };
  }

};
const __default13 = {
  encode(_packet) {
    const packetType = 14;
    const flags = 0;
    return [14 << 4 | 0, 0];
  },

  decode(_buffer, _remainingStart, _remainingLength) {
    return {
      type: 'disconnect'
    };
  }

};
const packetTypesByName = {
  connect: __default,
  connack: __default1,
  publish: __default2,
  puback: __default3,
  pubrec: __default4,
  pubrel: __default5,
  pubcomp: __default6,
  subscribe: __default7,
  suback: __default8,
  unsubscribe: __default9,
  unsuback: __default10,
  pingreq: __default11,
  pingres: __default12,
  disconnect: __default13
};
const packetTypesById = [null, __default, __default1, __default2, __default3, __default4, __default5, __default6, __default7, __default8, __default9, __default10, __default11, __default12, __default13];

function encode1(packet, utf8Encoder) {
  const name = packet.type;
  const packetType = packetTypesByName[name];

  if (!packetType) {
    throw new Error(`packet type ${name} cannot be encoded`);
  }

  return Uint8Array.from(packetType.encode(packet, utf8Encoder));
}

function decode1(buffer, utf8Decoder) {
  if (buffer.length < 2) {
    return null;
  }

  const id = buffer[0] >> 4;
  const packetType = packetTypesById[id];

  if (!packetType) {
    throw new Error(`packet type ${id} cannot be decoded`);
  }

  const {
    length: remainingLength,
    bytesUsedToEncodeLength
  } = decodeLength(buffer, 1);
  const packetLength = 1 + bytesUsedToEncodeLength + remainingLength;

  if (buffer.length < packetLength) {
    return null;
  }

  const packet = packetType.decode(buffer, 1 + bytesUsedToEncodeLength, remainingLength, utf8Decoder);

  if (!packet) {
    return null;
  }

  const packetWithLength = packet;
  packetWithLength.length = packetLength;
  return packetWithLength;
}

export { encode1 as encode };
export { decode1 as decode };
const packetIdLimit = 2 ** 16;

class IncomingStore {}

class IncomingMemoryStore extends IncomingStore {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "packets", new Set());
  }

  async store(packetId) {
    this.packets.add(packetId);
  }

  async has(packetId) {
    return this.packets.has(packetId);
  }

  async discard(packetId) {
    this.packets.delete(packetId);
  }

}

class OutgoingStore {}

class OutgoingMemoryStore extends OutgoingStore {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "packets", new Map());
  }

  async store(packet) {
    if (!packet.id) {
      throw new Error('missing packet.id');
    }

    this.packets.set(packet.id, packet);
  }

  async discard(packetId) {
    this.packets.delete(packetId);
  }

  async *iterate() {
    for (const value of this.packets.values()) {
      yield value;
    }
  }

}

const defaultPorts = {
  mqtt: 1883,
  mqtts: 8883,
  ws: 80,
  wss: 443
};
const defaultClientIdPrefix = 'mqttts';
const defaultKeepAlive = 60;
const defaultConnectTimeout = 10 * 1000;
const defaultConnectOptions = {
  retries: Infinity,
  minDelay: 1000,
  maxDelay: 2000,
  factor: 1.1,
  random: false
};
const defaultReconnectOptions = {
  retries: Infinity,
  minDelay: 1000,
  maxDelay: 60000,
  factor: 1.1,
  random: true
};

class Client2 {
  constructor(options1) {
    _defineProperty(this, "options", void 0);

    _defineProperty(this, "url", void 0);

    _defineProperty(this, "clientId", void 0);

    _defineProperty(this, "keepAlive", void 0);

    _defineProperty(this, "connectionState", 'offline');

    _defineProperty(this, "everConnected", false);

    _defineProperty(this, "disconnectRequested", false);

    _defineProperty(this, "reconnectAttempt", 0);

    _defineProperty(this, "subscriptions", []);

    _defineProperty(this, "lastPacketId", 0);

    _defineProperty(this, "lastPacketTime", void 0);

    _defineProperty(this, "buffer", null);

    _defineProperty(this, "unresolvedConnect", void 0);

    _defineProperty(this, "queuedPublishes", []);

    _defineProperty(this, "unresolvedPublishes", new Map());

    _defineProperty(this, "incomingStore", void 0);

    _defineProperty(this, "outgoingStore", void 0);

    _defineProperty(this, "unresolvedSubscribes", new Map());

    _defineProperty(this, "unresolvedUnsubscribes", new Map());

    _defineProperty(this, "unacknowledgedSubscribes", new Map());

    _defineProperty(this, "unacknowledgedUnsubscribes", new Map());

    _defineProperty(this, "eventListeners", new Map());

    _defineProperty(this, "timers", {});

    _defineProperty(this, "log", void 0);

    this.options = options1 || {};
    this.clientId = this.generateClientId();
    this.keepAlive = typeof this.options.keepAlive === 'number' ? this.options.keepAlive : defaultKeepAlive;
    this.incomingStore = this.options.incomingStore || new IncomingMemoryStore();
    this.outgoingStore = this.options.outgoingStore || new OutgoingMemoryStore();

    this.log = this.options.logger || (() => {});
  }

  async connect() {
    switch (this.connectionState) {
      case 'offline':
      case 'disconnected':
        break;

      default:
        throw new Error(`should not be connecting in ${this.connectionState} state`);
    }

    this.disconnectRequested = false;
    const deferred = new Deferred();
    this.unresolvedConnect = deferred;
    this.openConnection();
    return deferred.promise;
  }

  async publish(topic, payload, options) {
    const dup = options && options.dup || false;
    const qos = options && options.qos || 0;
    const retain = options && options.retain || false;
    const id = qos > 0 ? this.nextPacketId() : 0;
    const packet = {
      type: 'publish',
      dup,
      qos,
      retain,
      topic,
      payload,
      id
    };
    const deferred = new Deferred();

    if (this.connectionState === 'connected') {
      this.sendPublish(packet, deferred);
    } else {
      this.log('queueing publish');
      this.queuedPublishes.push({
        packet,
        deferred
      });
    }

    return deferred.promise;
  }

  async flushQueuedPublishes() {
    let queued;

    while (queued = this.queuedPublishes.shift()) {
      const {
        packet,
        deferred
      } = queued;
      this.sendPublish(packet, deferred);
    }
  }

  async flushUnacknowledgedPublishes() {
    for await (const packet of this.outgoingStore.iterate()) {
      if (packet.type === 'publish') {
        await this.send({ ...packet,
          dup: true
        });
      } else {
        await this.send(packet);
      }
    }
  }

  async sendPublish(packet, deferred) {
    if (packet.qos && packet.qos > 0) {
      this.unresolvedPublishes.set(packet.id, deferred);
      this.outgoingStore.store(packet);
    }

    await this.send(packet);

    if (!packet.qos) {
      deferred.resolve();
    }
  }

  async subscribe(input, qos) {
    switch (this.connectionState) {
      case 'disconnecting':
      case 'disconnected':
        throw new Error(`should not be subscribing in ${this.connectionState} state`);
    }

    const arr = Array.isArray(input) ? input : [input];
    const subs = arr.map(sub => {
      return typeof sub === 'object' ? {
        topicFilter: sub.topicFilter,
        qos: sub.qos || qos || 0,
        state: 'pending'
      } : {
        topicFilter: sub,
        qos: qos || 0,
        state: 'pending'
      };
    });
    const promises = [];

    for (const sub of subs) {
      this.subscriptions = this.subscriptions.filter(old => old.topicFilter !== sub.topicFilter);
      this.subscriptions.push(sub);
      const deferred = new Deferred();
      this.unresolvedSubscribes.set(sub.topicFilter, deferred);
      promises.push(deferred.promise.then(() => sub));
    }

    await this.flushSubscriptions();
    return Promise.all(promises);
  }

  async flushSubscriptions() {
    const subs = this.subscriptions.filter(sub => sub.state === 'pending');

    if (subs.length > 0 && this.connectionState === 'connected') {
      await this.sendSubscribe(subs);
    }
  }

  async sendSubscribe(subscriptions) {
    const subscribePacket = {
      type: 'subscribe',
      id: this.nextPacketId(),
      subscriptions: subscriptions.map(sub => ({
        topicFilter: sub.topicFilter,
        qos: sub.qos
      }))
    };
    this.unacknowledgedSubscribes.set(subscribePacket.id, {
      subscriptions
    });
    await this.send(subscribePacket);

    for (const sub of subscriptions) {
      sub.state = 'unacknowledged';
    }
  }

  async unsubscribe(input) {
    switch (this.connectionState) {
      case 'disconnecting':
      case 'disconnected':
        throw new Error(`should not be unsubscribing in ${this.connectionState} state`);
    }

    const arr = Array.isArray(input) ? input : [input];
    const promises = [];

    for (const topicFilter of arr) {
      const sub = this.subscriptions.find(sub1 => sub1.topicFilter === topicFilter) || {
        topicFilter,
        qos: 0,
        state: 'unknown'
      };
      const deferred = new Deferred();
      const promise = deferred.promise.then(() => sub);

      if (this.connectionState !== 'connected' && this.options.clean !== false) {
        sub.state = 'removed';
      } else {
        switch (sub.state) {
          case 'pending':
            sub.state = 'removed';
            break;

          case 'removed':
          case 'replaced':
            break;

          case 'unknown':
          case 'unacknowledged':
          case 'acknowledged':
            sub.state = 'unsubscribe-pending';
            break;

          case 'unsubscribe-pending':
          case 'unsubscribe-unacknowledged':
          case 'unsubscribe-acknowledged':
            break;
        }
      }

      this.unresolvedUnsubscribes.set(topicFilter, deferred);
      promises.push(promise);
    }

    await this.flushUnsubscriptions();
    return Promise.all(promises);
  }

  async flushUnsubscriptions() {
    const subs = [];

    for (const sub of this.subscriptions) {
      if (sub.state === 'removed') {
        const unresolvedSubscribe = this.unresolvedSubscribes.get(sub.topicFilter);

        if (unresolvedSubscribe) {
          this.unresolvedSubscribes.delete(sub.topicFilter);
          unresolvedSubscribe.resolve(null);
        }

        const unresolvedUnsubscribe = this.unresolvedUnsubscribes.get(sub.topicFilter);

        if (unresolvedUnsubscribe) {
          this.unresolvedUnsubscribes.delete(sub.topicFilter);
          unresolvedUnsubscribe.resolve(null);
        }
      }

      if (sub.state === 'unsubscribe-pending') {
        subs.push(sub);
      }
    }

    this.subscriptions = this.subscriptions.filter(sub1 => sub1.state !== 'removed');

    if (subs.length > 0 && this.connectionState === 'connected') {
      await this.sendUnsubscribe(subs);
    }
  }

  async sendUnsubscribe(subscriptions) {
    const unsubscribePacket = {
      type: 'unsubscribe',
      id: this.nextPacketId(),
      topicFilters: subscriptions.map(sub => sub.topicFilter)
    };
    this.unacknowledgedUnsubscribes.set(unsubscribePacket.id, {
      subscriptions
    });
    await this.send(unsubscribePacket);

    for (const sub of subscriptions) {
      sub.state = 'unsubscribe-unacknowledged';
    }
  }

  async disconnect() {
    switch (this.connectionState) {
      case 'connected':
        await this.doDisconnect();
        break;

      case 'connecting':
        this.disconnectRequested = true;
        break;

      case 'offline':
        this.changeState('disconnected');
        this.stopTimers();
        break;

      default:
        throw new Error(`should not be disconnecting in ${this.connectionState} state`);
    }
  }

  async doDisconnect() {
    this.changeState('disconnecting');
    this.stopTimers();
    await this.send({
      type: 'disconnect'
    });
    await this.close();
  }

  encode(packet, utf8Encoder) {
    return encode1(packet, utf8Encoder);
  }

  decode(bytes, utf8Decoder) {
    return decode1(bytes, utf8Decoder);
  }

  async openConnection() {
    try {
      this.changeState('connecting');
      this.url = this.getURL();
      this.log(`opening connection to ${this.url}`);
      await this.open(this.url);
      await this.send({
        type: 'connect',
        clientId: this.clientId,
        username: this.options.username,
        password: this.options.password,
        clean: this.options.clean !== false,
        keepAlive: this.keepAlive
      });
      this.startConnectTimer();
    } catch (err) {
      this.log(`caught error opening connection: ${err.message}`);
      this.changeState('offline');

      if (!this.startReconnectTimer()) {
        this.notifyConnectRejected(new Error('connection failed'));
      }
    }
  }

  async connectionEstablished(connackPacket) {
    if (this.options.clean !== false || !connackPacket.sessionPresent) {
      for (const sub of this.subscriptions) {
        if (sub.state === 'unsubscribe-pending') {
          sub.state = 'removed';
        } else {
          sub.state = 'pending';
        }
      }
    }

    await this.flushSubscriptions();
    await this.flushUnsubscriptions();
    await this.flushUnacknowledgedPublishes();
    await this.flushQueuedPublishes();

    if (this.unresolvedConnect) {
      this.log('resolving initial connect');
      this.unresolvedConnect.resolve(connackPacket);
    }

    if (this.disconnectRequested) {
      this.doDisconnect();
    } else {
      this.startKeepAliveTimer();
    }
  }

  connectionClosed() {
    this.log('connectionClosed');

    switch (this.connectionState) {
      case 'disconnecting':
        this.changeState('disconnected');
        break;

      default:
        this.changeState('offline');
        this.reconnectAttempt = 0;
        this.startReconnectTimer();
        break;
    }

    this.stopKeepAliveTimer();
  }

  connectionError(error) {
    this.log('connectionError', error);
  }

  bytesReceived(bytes) {
    this.log('bytes received', bytes);
    this.emit('bytesreceived', bytes);
    let buffer = bytes;
    const oldBuffer = this.buffer;

    if (oldBuffer) {
      const newBuffer = new Uint8Array(oldBuffer.length + bytes.length);
      newBuffer.set(oldBuffer);
      newBuffer.set(bytes, oldBuffer.length);
      buffer = newBuffer;
    } else {
      buffer = bytes;
    }

    do {
      const packet = this.decode(buffer);

      if (!packet) {
        break;
      }

      this.log(`received ${packet.type} packet`, packet);
      this.packetReceived(packet);

      if (packet.length < buffer.length) {
        buffer = buffer.slice(packet.length);
      } else {
        buffer = null;
      }
    } while (buffer);

    this.buffer = buffer;
  }

  packetReceived(packet) {
    this.emit('packetreceive', packet);

    switch (packet.type) {
      case 'connack':
        this.handleConnack(packet);
        break;

      case 'publish':
        this.handlePublish(packet);
        break;

      case 'puback':
        this.handlePuback(packet);
        break;

      case 'pubrec':
        this.handlePubrec(packet);
        break;

      case 'pubrel':
        this.handlePubrel(packet);
        break;

      case 'pubcomp':
        this.handlePubcomp(packet);
        break;

      case 'suback':
        this.handleSuback(packet);
        break;

      case 'unsuback':
        this.handleUnsuback(packet);
        break;
    }
  }

  protocolViolation(msg) {
    this.log('protocolViolation', msg);
  }

  handleConnack(packet) {
    switch (this.connectionState) {
      case 'connecting':
        break;

      default:
        throw new Error(`should not be receiving connack packets in ${this.connectionState} state`);
    }

    this.changeState('connected');
    this.everConnected = true;
    this.stopConnectTimer();
    this.connectionEstablished(packet);
  }

  async handlePublish(packet) {
    if (packet.qos === 0) {
      this.emit('message', packet.topic, packet.payload, packet);
    } else if (packet.qos === 1) {
      if (typeof packet.id !== 'number' || packet.id < 1) {
        return this.protocolViolation('publish packet with qos 1 is missing id');
      }

      this.emit('message', packet.topic, packet.payload, packet);
      this.send({
        type: 'puback',
        id: packet.id
      });
    } else if (packet.qos === 2) {
      if (typeof packet.id !== 'number' || packet.id < 1) {
        return this.protocolViolation('publish packet with qos 2 is missing id');
      }

      const emitMessage = !packet.dup || !(await this.incomingStore.has(packet.id));

      if (emitMessage) {
        this.incomingStore.store(packet.id);
        this.emit('message', packet.topic, packet.payload, packet);
      }

      this.send({
        type: 'pubrec',
        id: packet.id
      });
    }
  }

  handlePuback(packet) {
    this.outgoingStore.discard(packet.id);
    const deferred = this.unresolvedPublishes.get(packet.id);

    if (deferred) {
      this.unresolvedPublishes.delete(packet.id);
      deferred.resolve();
    } else {
      this.log(`received puback packet with unrecognized id ${packet.id}`);
    }
  }

  handlePubrec(packet) {
    const pubrel = {
      type: 'pubrel',
      id: packet.id
    };
    this.outgoingStore.store(pubrel);
    this.send(pubrel);
  }

  handlePubrel(packet) {
    this.incomingStore.discard(packet.id);
    this.send({
      type: 'pubcomp',
      id: packet.id
    });
  }

  handlePubcomp(packet) {
    this.outgoingStore.discard(packet.id);
    const deferred = this.unresolvedPublishes.get(packet.id);

    if (deferred) {
      this.unresolvedPublishes.delete(packet.id);
      deferred.resolve();
    } else {
      this.log(`received pubcomp packet with unrecognized id ${packet.id}`);
    }
  }

  handleSuback(packet) {
    const unacknowledgedSubscribe = this.unacknowledgedSubscribes.get(packet.id);

    if (unacknowledgedSubscribe) {
      this.unacknowledgedSubscribes.delete(packet.id);
      let i = 0;

      for (const sub of unacknowledgedSubscribe.subscriptions) {
        sub.state = 'acknowledged';
        sub.returnCode = packet.returnCodes[i++];
        const deferred = this.unresolvedSubscribes.get(sub.topicFilter);

        if (deferred) {
          this.unresolvedSubscribes.delete(sub.topicFilter);
          deferred.resolve(packet);
        }
      }
    } else {
      throw new Error(`received suback packet with unrecognized id ${packet.id}`);
    }
  }

  handleUnsuback(packet) {
    const unacknowledgedUnsubscribe = this.unacknowledgedUnsubscribes.get(packet.id);

    if (unacknowledgedUnsubscribe) {
      this.unacknowledgedUnsubscribes.delete(packet.id);

      for (const sub of unacknowledgedUnsubscribe.subscriptions) {
        if (!sub) {
          continue;
        }

        sub.state = 'unsubscribe-acknowledged';
        this.subscriptions = this.subscriptions.filter(s => s !== sub);
        const deferred = this.unresolvedUnsubscribes.get(sub.topicFilter);

        if (deferred) {
          this.unresolvedUnsubscribes.delete(sub.topicFilter);
          deferred.resolve(packet);
        }
      }
    } else {
      throw new Error(`received unsuback packet with unrecognized id ${packet.id}`);
    }
  }

  startConnectTimer() {
    this.startTimer('connect', () => {
      this.connectTimedOut();
    }, this.options.connectTimeout || defaultConnectTimeout);
  }

  connectTimedOut() {
    switch (this.connectionState) {
      case 'connecting':
        break;

      default:
        throw new Error(`connect timer should not be timing out in ${this.connectionState} state`);
    }

    this.changeState('offline');
    this.close();
    this.notifyConnectRejected(new Error('connect timed out'));
    this.reconnectAttempt = 0;
    this.startReconnectTimer();
  }

  notifyConnectRejected(err) {
    if (this.unresolvedConnect) {
      this.log('rejecting initial connect');
      this.unresolvedConnect.reject(err);
    }
  }

  stopConnectTimer() {
    if (this.timerExists('connect')) {
      this.stopTimer('connect');
    }
  }

  startReconnectTimer() {
    var _reconnectOptions$ret, _reconnectOptions$min, _reconnectOptions$max, _reconnectOptions$fac, _reconnectOptions$ran;

    const options2 = this.options;
    let reconnectOptions;
    let defaultOptions;

    if (!this.everConnected) {
      reconnectOptions = options2.connect || {};
      defaultOptions = defaultConnectOptions;
    } else {
      reconnectOptions = options2.reconnect || {};
      defaultOptions = defaultReconnectOptions;
    }

    if (reconnectOptions === false) {
      return;
    } else if (reconnectOptions === true) {
      reconnectOptions = {};
    }

    const attempt = this.reconnectAttempt;
    const maxAttempts = (_reconnectOptions$ret = reconnectOptions.retries) !== null && _reconnectOptions$ret !== void 0 ? _reconnectOptions$ret : defaultOptions.retries;

    if (attempt >= maxAttempts) {
      return false;
    }

    const min = (_reconnectOptions$min = reconnectOptions.minDelay) !== null && _reconnectOptions$min !== void 0 ? _reconnectOptions$min : defaultOptions.minDelay;
    const max = (_reconnectOptions$max = reconnectOptions.maxDelay) !== null && _reconnectOptions$max !== void 0 ? _reconnectOptions$max : defaultOptions.maxDelay;
    const factor = (_reconnectOptions$fac = reconnectOptions.factor) !== null && _reconnectOptions$fac !== void 0 ? _reconnectOptions$fac : defaultOptions.factor;
    const random = (_reconnectOptions$ran = reconnectOptions.random) !== null && _reconnectOptions$ran !== void 0 ? _reconnectOptions$ran : defaultOptions.random;
    const thisDelay = min * Math.pow(factor, attempt);
    const nextDelay = min * Math.pow(factor, attempt + 1);
    const diff = nextDelay - thisDelay;
    const randomness = random ? diff * Math.random() : 0;
    const delay = Math.floor(Math.min(thisDelay + randomness, max));
    this.log(`reconnect attempt ${attempt + 1} in ${delay}ms`);
    this.startTimer('reconnect', () => {
      this.reconnectAttempt++;
      this.openConnection();
    }, delay);
    return true;
  }

  stopReconnectTimer() {
    if (this.timerExists('reconnect')) {
      this.stopTimer('reconnect');
    }
  }

  startKeepAliveTimer() {
    if (!this.keepAlive) {
      return;
    }

    const elapsed = Date.now() - this.lastPacketTime.getTime();
    const timeout = this.keepAlive * 1000 - elapsed;
    this.startTimer('keepAlive', () => this.sendKeepAlive(), timeout);
  }

  stopKeepAliveTimer() {
    if (this.timerExists('keepAlive')) {
      this.stopTimer('keepAlive');
    }
  }

  async sendKeepAlive() {
    if (this.connectionState === 'connected') {
      const elapsed = Date.now() - this.lastPacketTime.getTime();
      const timeout = this.keepAlive * 1000;

      if (elapsed >= timeout) {
        await this.send({
          type: 'pingreq'
        });
      }

      this.startKeepAliveTimer();
    } else {
      this.log('keepAliveTimer should have been cancelled');
    }
  }

  stopTimers() {
    this.stopConnectTimer();
    this.stopReconnectTimer();
    this.stopKeepAliveTimer();
  }

  startTimer(name, cb, delay) {
    if (this.timerExists(name)) {
      this.log(`timer ${name} already exists`);
      this.stopTimer(name);
    }

    this.log(`starting timer ${name} for ${delay}ms`);
    this.timers[name] = setTimeout(() => {
      delete this.timers[name];
      this.log(`invoking timer ${name} callback`);
      cb();
    }, delay);
  }

  stopTimer(name) {
    if (!this.timerExists(name)) {
      this.log(`no timer ${name} to stop`);
      return;
    }

    this.log(`stopping timer ${name}`);
    const id = this.timers[name];

    if (id) {
      clearTimeout(id);
      delete this.timers[name];
    }
  }

  timerExists(name) {
    return !!this.timers[name];
  }

  changeState(newState) {
    const oldState = this.connectionState;
    this.connectionState = newState;
    this.log(`connectionState: ${oldState} -> ${newState}`);
    this.emit('statechange', {
      from: oldState,
      to: newState
    });
    this.emit(newState);
  }

  generateClientId() {
    let clientId;

    if (typeof this.options.clientId === 'string') {
      clientId = this.options.clientId;
    } else if (typeof this.options.clientId === 'function') {
      clientId = this.options.clientId();
    } else {
      const prefix = this.options.clientIdPrefix || defaultClientIdPrefix;
      const suffix = Math.random().toString(36).slice(2);
      clientId = `${prefix}-${suffix}`;
    }

    return clientId;
  }

  getURL() {
    let url = typeof this.options.url === 'function' ? this.options.url() : this.options.url;

    if (!url) {
      url = this.getDefaultURL();
    }

    if (typeof url === 'string') {
      url = this.parseURL(url);
    }

    const protocol = url.protocol.slice(0, -1);

    if (!url.port) {
      url.port = defaultPorts[protocol].toString();
    }

    this.validateURL(url);
    return url;
  }

  parseURL(url) {
    let parsed = new URL(url);

    if (!parsed.hostname && parsed.pathname.startsWith('//')) {
      const protocol = parsed.protocol;
      parsed = new URL(url.replace(protocol, 'http:'));
      parsed.protocol = protocol;
    }

    return parsed;
  }

  nextPacketId() {
    this.lastPacketId = (this.lastPacketId + 1) % packetIdLimit;

    if (!this.lastPacketId) {
      this.lastPacketId = 1;
    }

    return this.lastPacketId;
  }

  async send(packet) {
    this.log(`sending ${packet.type} packet`, packet);
    this.emit('packetsend', packet);
    const bytes = this.encode(packet);
    this.emit('bytessent', bytes);
    await this.write(bytes);
    this.lastPacketTime = new Date();
  }

  on(eventName, listener) {
    let listeners = this.eventListeners.get(eventName);

    if (!listeners) {
      listeners = [];
      this.eventListeners.set(eventName, listeners);
    }

    listeners.push(listener);
  }

  off(eventName, listener) {
    const listeners = this.eventListeners.get(eventName);

    if (listeners) {
      this.eventListeners.set(eventName, listeners.filter(l => l !== listener));
    }
  }

  emit(eventName, ...args) {
    const listeners = this.eventListeners.get(eventName);

    if (listeners) {
      for (const listener of listeners) {
        listener(...args);
      }
    }
  }

}

class Deferred {
  constructor() {
    _defineProperty(this, "promise", void 0);

    _defineProperty(this, "resolve", void 0);

    _defineProperty(this, "reject", void 0);

    this.promise = new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

}

const utf8Encoder = new TextEncoder();
const utf8Decoder = new TextDecoder();

class Client1 extends Client2 {
  constructor(options2) {
    super(options2);

    _defineProperty(this, "ws", void 0);
  }

  getDefaultURL() {
    return 'ws://localhost';
  }

  validateURL(url) {
    if (!(url.protocol === 'ws:' || url.protocol === 'wss:')) {
      throw new Error(`URL protocol must be ws or wss`);
    }
  }

  async open(url) {
    let closed = true;
    return new Promise((resolve, reject) => {
      const ws = new WebSocket(url.toString(), 'mqtt');
      ws.binaryType = 'arraybuffer';
      this.ws = ws;

      ws.onopen = () => {
        this.log('connection made');
        closed = false;
        ws.onopen = null;

        ws.onmessage = message => {
          const bytes = new Uint8Array(message.data);
          this.bytesReceived(bytes);
        };

        ws.onclose = () => {
          if (!closed) {
            closed = true;
            this.connectionClosed();
          }
        };

        ws.onerror = _err => {
          if (!closed) {
            closed = true;
            this.connectionClosed();
          }
        };

        resolve();
      };

      ws.onerror = err => {
        this.log('connection error');
        ws.onopen = null;
        ws.onerror = null;
        reject(err);
      };
    });
  }

  async write(bytes) {
    if (!this.ws) {
      throw new Error('no connection');
    }

    this.log('writing bytes', bytes);
    this.ws.send(bytes);
  }

  async close() {
    if (!this.ws) {
      throw new Error('no connection');
    }

    this.ws.close();
  }

  encode(packet) {
    return super.encode(packet, utf8Encoder);
  }

  decode(bytes) {
    return super.decode(bytes, utf8Decoder);
  }

}

export { Client1 as Client };

